
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spa/facilities/[id]",
      function () {
        return require("private-next-pages/spa/facilities/[id]/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spa/facilities/[id]"])
      });
    }
  